import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { uploadMedia, resetStore } from '../../reducers/media/duck';
import UploadMedia from './UploadMedia';

const mapStateToProps = ({
  mediaStore: {
    uploadMediaStatus,
    uploadMediaError,
  }, createAppStore: {
    apps,
  }, campaignStore: {
    campaignId,
  },
}) => ({
  uploadMediaStatus, apps, campaignId, uploadMediaError,
});
const mapDispatchToProps = {
  uploadMedia,
  resetStore,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UploadMedia));



// WEBPACK FOOTER //
// ./src/containers/UploadMedia/index.js